import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { ThunkAction, Action } from '@reduxjs/toolkit';

// Import slices
import authReducer from './slices/authSlice';
import activationReducer from './slices/activationSlice';
// import productReducer from './slices/productSlice';
// import stockReducer from './slices/stockSlice';
// import purchaseReducer from './slices/purchaseSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    activation: activationReducer,
    // products: productReducer,
    // stock: stockReducer,
    // purchases: purchaseReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Enable listener behavior for the store
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>; 